import { cn } from "@/lib/utils";

interface ListProps {
  children: React.ReactNode;
  className?: string;
}

interface ListItemProps {
  children: React.ReactNode;
  className?: string;
  bullet?: string;
}

export function List({ children, className }: ListProps) {
  return <ul className={cn("list-none li > pl-[6px]", className)}>{children}</ul>;
}

export function ListItem({ children, className, bullet = "•" }: ListItemProps) {
  return (
    <li
      className={cn(
        "pl-3 relative",
        "before:content-[attr(data-bullet)] before:absolute before:left-0 before:top-[-0.1em]",
        className,
      )}
      data-bullet={bullet}
    >
      {children}
    </li>
  );
}
